import './Legal.css';

export default function Terms() {
  return (
    <main className="legal">
      <section className="legal__hero">
        <div className="container">
          <p className="label">⚛ Legal</p>
          <h1 className="legal__heading">Terms &amp; Conditions</h1>
          <p className="legal__meta">Last updated: January 2024</p>
        </div>
      </section>

      <section className="legal__content">
        <div className="container legal__body">

          <div className="legal__section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using the Nuclear Society of Kenya website
              (nuclearsocietyofkenya.org), you accept and agree to be bound by
              these Terms and Conditions. If you do not agree, please do not use
              this website.
            </p>
          </div>

          <div className="legal__section">
            <h2>2. About NSK</h2>
            <p>
              The Nuclear Society of Kenya is a professional body registered under
              the Societies Act of Kenya, dedicated to advancing the peaceful and
              safe use of nuclear science and technology in Kenya and East Africa.
            </p>
          </div>

          <div className="legal__section">
            <h2>3. Membership</h2>
            <p>
              Membership of NSK is subject to approval by the Executive Committee.
              NSK reserves the right to decline or terminate membership at its
              discretion. Membership fees are non-refundable once processed.
              Members must conduct themselves in accordance with NSK's Code of
              Professional Conduct at all times.
            </p>
          </div>

          <div className="legal__section">
            <h2>4. Intellectual Property</h2>
            <p>
              All content on this website — including text, graphics, logos, and
              images — is the property of the Nuclear Society of Kenya and is
              protected by applicable intellectual property laws. You may not
              reproduce, distribute, or use our content without prior written
              permission from NSK.
            </p>
          </div>

          <div className="legal__section">
            <h2>5. Disclaimer of Warranties</h2>
            <p>
              This website is provided on an "as is" basis. NSK makes no warranties,
              expressed or implied, regarding the accuracy, completeness, or
              suitability of the information provided. We do not warrant that the
              website will be uninterrupted or error-free.
            </p>
          </div>

          <div className="legal__section">
            <h2>6. Limitation of Liability</h2>
            <p>
              NSK shall not be liable for any direct, indirect, incidental, or
              consequential damages arising from your use of this website or
              reliance on any information provided herein. Always consult qualified
              nuclear professionals for technical advice.
            </p>
          </div>

          <div className="legal__section">
            <h2>7. External Links</h2>
            <p>
              Our website may contain links to third-party websites. These links
              are provided for your convenience only. NSK has no control over the
              content of those sites and accepts no responsibility for them or for
              any loss or damage that may arise from your use of them.
            </p>
          </div>

          <div className="legal__section">
            <h2>8. Governing Law</h2>
            <p>
              These Terms and Conditions are governed by and construed in accordance
              with the laws of Kenya. Any disputes arising shall be subject to the
              exclusive jurisdiction of the courts of Kenya.
            </p>
          </div>

          <div className="legal__section">
            <h2>9. Changes to Terms</h2>
            <p>
              NSK reserves the right to update these Terms and Conditions at any
              time. Changes will be posted on this page with an updated date.
              Continued use of the website after changes constitutes acceptance
              of the new terms.
            </p>
          </div>

          <div className="legal__section">
            <h2>10. Contact</h2>
            <p>
              For questions regarding these Terms, contact us at{' '}
              <a href="mailto:info@nuclearsocietyofkenya.org">
                info@nuclearsocietyofkenya.org
              </a>.
            </p>
          </div>

        </div>
      </section>
    </main>
  );
}